export default __webpack_public_path__ + "static/media/0x831753dd7087cac61ab5644b308642cc1c33dc13.536e9161.png";